// extracted by mini-css-extract-plugin
module.exports = {"paymentsAccordions__accordionContent":"PaymentsAccordions_paymentsAccordions__accordionContent__mUjwG"};